import React from 'react'
import * as Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import highchartsStock from 'highcharts/modules/stock'
import { useTheme } from 'styled-components'

import buildOptions from './graph.helpers'
import { GraphProps } from './graph.types'
import { t } from '../../../infrastructure/translation/customTranslation'
import { ChartWrapper } from './graph.styles'

highchartsStock(Highcharts)

const highchartsContainerProps = {
  style: { height: 'calc(100% - 3rem)', width: 'calc(100% - 4rem)', position: 'absolute' },
}

const mobileHighchartsContainerProps = {
  style: { height: 'calc(100% - 1rem)', width: '100%', position: 'absolute' },
}

const setLangHighchart = (OriginalHighcharts: typeof Highcharts) => {
  OriginalHighcharts.setOptions({
    lang: {
      months: [
        t('january'),
        t('february'),
        t('march'),
        t('april'),
        t('may'),
        t('june'),
        t('july'),
        t('august'),
        t('september'),
        t('october'),
        t('november'),
        t('december'),
      ],
      weekdays: [
        t('sunday'),
        t('monday'),
        t('tuesday'),
        t('wednesday'),
        t('thursday'),
        t('friday'),
        t('saturday'),
      ],
    },
  })
}

const Highchart = (props: HighchartsReact.Props) => {
  const { options } = props
  setLangHighchart(Highcharts)
  const { isMobile } = useTheme() as { isMobile: boolean }

  const highChartProps = isMobile ? mobileHighchartsContainerProps : highchartsContainerProps
  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      allowChartUpdate
      constructorType="chart"
      containerProps={highChartProps}
      {...props}
    />
  )
}

const Graph = (props: GraphProps): React.ReactElement => {
  const { isMobile } = useTheme() as { isMobile: boolean }
  const { data, units, interval } = props
  const options = buildOptions(data, units, interval, isMobile)
  return (
    <ChartWrapper>
      <Highchart options={options} />
    </ChartWrapper>
  )
}

export default Graph
